<template>
    <div class="pt-select-div" v-if="$attrs.mode == 'multiple'">
        <a-select  :allowClear="allowClear" :style="selectStyle" :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
            <a-icon slot="suffixIcon" type="caret-down" />
            <a-select-option v-for="(item,inde) in users" :key="inde" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid"><div><span>{{item.userName}}</span></div></a-select-option>
        </a-select>
        <a-icon class="multiple-icon" :class="open?'openClass':''" type="caret-down"></a-icon>
    </div>
   <a-select v-else :allowClear="allowClear"  :filterOption="filterOption"  showSearch @change="changeValue" :optionLabelProp="optionLabelProp" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
     <a-icon slot="suffixIcon" type="caret-down" />
     <a-select-option v-for="(item,inde) in users" :key="inde" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid" :label="showCompanyLable? item.userName  + '   ' +item.companyName  :item.userName  "><div class="option_div"><span>{{item.userName}}</span><span v-if="showCompany">{{item.companyName}}</span></div></a-select-option>
   </a-select>
</template>

<script>
  import UserApi from '@/api/sys/user'
  export default {
    name: 'ptUserSelect',
    props:{
      placeholder:{
        type:String,
        default:"请选择",
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [Object, Array] | String,
      },
      disabledUsers:{
        type:Array,
        default:()=>{return []}
      },
      companyId:{
        type:String,
      },
      depId:{
        type:String,
      },
      selectStyle:{
        type:Object,
        default:()=>{
          return {width:'100%'}
        }
      },
      showCompany:{
        type:Boolean,
        default:false,
      },
      optionLabelProp:{
        type:String,
        default:'label'
      },
      showCompanyLable:{
        type:Boolean,
        default:false,
      }
    },
    data() {
      return {
        input:this.value,
        users:[],
        open:false,
      }
    },
    watch:{
      value (val) {
        this.input = val
        console.log("this.input",val)
      },
      input(val){
        this.$emit('input',val)
      },
      companyId(){
        this.initData()
      },
      depId(){
        this.initData()
      },
    },
    mounted(){
      this.initData()
    },
    methods:{
      dropdownVisibleChange(open){
        this.open = open
      },
      filterOption(input, option){
        return (
          option.componentOptions.children[0].children[0].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      initData() {
        let queryVO ={}
        if(this.companyId){
          queryVO.companyId = this.companyId
        }
        if(this.depId){
          queryVO.depId = this.depId
        }
        console.log("default======",this.depId)
        UserApi.selectUsers(queryVO).then(res => {
          if (res.code == 1) {
            this.users = res.data
          }
        })
      },
      changeValue(value){
        this.$emit('input',value)
        this.$emit('change',value);
      }
    }
  }
</script>

<style scoped lang="less">
    .pt-select-div{
        position: relative;
        width: 100%;
        display: inline;
        /deep/ .ant-select-selection--multiple .ant-select-selection__placeholder{
            margin-left: 0px;
        }
        .multiple-icon{
            position: absolute;
            color: rgba(0, 0, 0, 0.25);
            right: 11px;
            top: 10px;
            font-size: 12px;
        }
        .openClass{
            transform: rotate(180deg);
        }

    }

    .option_div{
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
</style>